import { createAsyncSaga, name, endpoints } from '../dependencies'

const updatePublisher = createAsyncSaga(
    `${name}/updatePublisher`,
    function* ({
        payload,
        fulfilled,
        rejected,
        request,
    }) {
        try {
            if (!payload.publisher_id) {
                throw new Error('publisher not provided')
            }
            
            const response = yield request({
                method: 'put',
                baseURL: endpoints.PICO_API_URL(),
                url: `${endpoints.PUBLISHER()}`,
                headers: {
                    publisherid: payload.publisher_id
                },
                data: {
                    ...payload
                }
            })

            yield fulfilled({
                ...response,
                calledFrom: 'updatePublisher'
            })
        } catch (error) {
            yield rejected(error?.response?.data?.message || error?.message || error)

        }
    }
)



export default updatePublisher
